import { z } from "zod";

import { MiddleMsCreateFormDataRuleGroupRequestType } from "@/api/graphql/types/graphql";

export const CreationFormRuleSchema = z.object({
  codes: z.string().optional(),
  description: z.string().optional(),
  enabled: z.boolean().optional(),
  enabledFor: z.string().optional(),
  disabledFor: z.string().optional(),
  groupCodeFor: z.array(z.string()).optional(),
  name: z.string(),
  rules: z.string(),
  type: z
    .enum([
      MiddleMsCreateFormDataRuleGroupRequestType.FormRuleTypeCreation,
      MiddleMsCreateFormDataRuleGroupRequestType.FormRuleTypeModification,
      MiddleMsCreateFormDataRuleGroupRequestType.FormRuleTypeCreationOrModification,
      MiddleMsCreateFormDataRuleGroupRequestType.FormRuleTypeCopy,
    ])
    .optional(),
});

export type CreationFormRuleType = z.infer<typeof CreationFormRuleSchema>;
